import version from "./version";

const path = '/v2';

const v2 = (url: string) => () => ({
  version: version(url + path)
})

export default v2;